import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { ContactUs } from '../contactUs';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import constants from '../../../core/utils/constants';

const tableHeaders: TableHeader[] = [
  { field: 'name', label: 'Name', align: 'left' },
  { field: 'email', label: 'Email', align: 'left' },
  { field: 'subject', label: 'Subject', align: 'left' },
  { field: 'message', label: 'Message', align: 'left' },
];
const ContactUsList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`${constants.authUrl}/contacts${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<ContactUs>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `${constants.authUrl}/contacts/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Item Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };
  return (
    <>
      <Layout>
        <Box sx={{ p: 2, maxWidth: 1200 }}>
          <TableContainer
            modelToken="contact"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Contact Us"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            routes={{
              edit: '/contacts/edit',
              create: '/contacts/create',
              delete: '/contacts',
              view: '/contacts',
            }}
            settings={{
              canCreate: false,
              canEdit: false,
              canDelete: true,
              canViewItem: false,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default ContactUsList;
